import React from 'react';
import BrandInfoContainer from 'features/BrandInfo';
import { useParams } from "react-router-dom";

const BrandTopicPage = () =>
{
	const { id } = useParams();
	return id != undefined ? <BrandInfoContainer id={id} /> : null;
}

export default BrandTopicPage;
